<template>
  <div class="p-5 flex flex-col flex-grow gap-2">
    <!-- Info -->
    <div class="flex flex-col text-black pb-5">
      <h2 class="text-2xl font-bold">Standard Excel Export</h2>
      <span class="text-md">Dies ist der Standard-Excel-Export. Bitte wählen Sie ein Magazine aus, das Sie Exportieren möchten. </span>
      <span class="text-md">Sie können normale sowie auch regionale Magazine Exportieren.</span>
    </div>

    <div class="flex flex-col flex-grow  gap-2 ">

      <div class="flex flex-col w-full   gap-2 flex-grow">
        <div class="flex">
          <span class="p-1 w-[150px]">Projekt:</span>
          <select
              class="outline-0 border border-bg-trader-input-border border-header p-1 w-full shadow-inner-2 text-gray-500"
              v-model="projectId">
            <option v-for="project in projectData.projects"
                    :key="project.projectId"
                    :value="project.projectId">
              {{ project.name }}
            </option>
          </select>
        </div>
        <div class="flex">
          <span class="p-1 w-[150px]">Magazine:</span>
          <select v-model="magazineId"
                  class="outline-0 border border-bg-trader-input-border border-header p-1 w-full  shadow-inner-2 text-gray-500">
            <option v-for="magazine in magazineData"
                    :key="magazine.magazineId"
                    :value="magazine.magazineId">
              {{ magazine.name }}
            </option>
          </select>
        </div>
        <div class="flex">
          <span class="p-1 w-[150px]">Einkaufsbereich:</span>
          <select v-model="purchaserId"
                  class="outline-0 border border-bg-trader-input-border border-header p-1 w-full  shadow-inner-2 text-gray-500">
            <option :value="0">Alle Einkaufsbereiche</option>
            <option v-for="purchaser in purchasers"
                    :value="purchaser.id"
                    :key="purchaser.id">
              {{ purchaser.teamIcon }} {{ purchaser.name }}
            </option>
          </select>
        </div>
        <div class="flex">
          <span class="p-1 w-[150px]">Information fixieren</span>
          <input class="outline-0 border border-bg-trader-input-border border-header p-1   shadow-inner-2 text-gray-500"
                 type="checkbox" v-model="isFreeze">
        </div>
      </div>
    </div>
    <div class="flex flex-col justify-between gap-2 flex-grow ">
      <div class="flex flex-col gap-2">
        <span>Seiten:</span>
        <div class="grid grid-cols-10  gap-2">
          <template v-for="page in pages" :key="page.pagePosition">
            <div class="flex z  p-2 bg cursor-pointer " @click="getPagePositions(page.pagePosition)"
                 :class="{
            'bg-trader-blue text-white' : pagePositions.includes(page.pagePosition),
            'bg-trader-dark-gray hover:bg-trader-darker-gray' : !pagePositions.includes(page.pagePosition),
          }">

              <span class="text-center w-full">{{ page.pagePosition }}</span>

            </div>
          </template>
        </div>

        <div class="flex gap-2  w-full ">
          <button class="text-center bg-trader-dark-gray hover:bg-trader-blue hover:text-white w-1/2 rounded p-2 "
                  @click="selectAllPagePosition">Alle Seiten auswählen
          </button>
          <button class="text-center bg-trader-dark-gray hover:bg-trader-blue hover:text-white w-1/2 rounded p-2 "
                  @click="deSelectAllPagePosition">Alle Seiten abwahlen
          </button>
        </div>
      </div>
    </div>

    <div class="flex gap-1 justify-between items-center">
      <button class=" text-center bg-trader-dark-gray hover:bg-trader-blue hover:text-white rounded p-2 min-w-[150px]">
        Abbrechen
      </button>

      <a @click="deleteTrue"
         :href="'/api/v3/excel/magazine/' + magazineId + '/purchaser/' + purchaserId + '/freeze/' + isFreeze + '/page/' + pagePositions.join(',')"
         target="_blank"
         class="text-trader-dark-red text-center bg-trader-red hover:bg-trader-blue hover:text-white rounded p-2 min-w-[150px] cursor-pointer ">Excel
        Export</a>
    </div>

  </div>
</template>

<script>
import {eventBus} from "@/application/EventBus.js";
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      projectData: [],
      projectId: 0,
      magazineId: 0,
      magazineData: [],
      purchasers: [],
      purchaserId: 0,
      isFreeze: false,
      pages: [],
      pagePositions: [1],
      selectedPurchasers: [0]
    };
  },
  mounted() {
    this.getProjects();
    this.getPurchaser();
    this.getPages();
  },
  created() {
    this.projectId = this.$route.params.projectId;
    this.magazineId = this.$route.params.magazineId;
  },
  methods: {
    getPagePositions(pagePosition) {
      if (this.pagePositions.includes(pagePosition)) {
        this.pagePositions = this.pagePositions.filter(position => position !== pagePosition);
      } else {
        this.pagePositions.push(pagePosition);
      }
    },
    selectAllPagePosition() {
      this.pagePositions = this.pages.map(page => page.pagePosition);
    },
    deSelectAllPagePosition() {
      this.pagePositions = [];
    },
    async getPages() {
      const response = await apolloClient.query({
        query: gql`
        query pages($filter: QueryFilter) {
          pages(filter: $filter) {
            pageId
            pagePosition

          }
        }
      `,
        variables: {
          filter: {
            magazineId: this.magazineId,
            // TODO bei regional muss die marketId übergeben werden bei nicht regional 0
            marketId: 2,
          }
        }
      });
      try {
        this.pages = response.data.pages;

      } catch (error) {
        console.error("Fehler beim Abrufen der Pages:", error);
      }
    },
    async getPurchaser() {
      try {
        // Apollo Client Anfrage
        const {data} = await apolloClient.query({
          query: gql`
          query getPurchasers {
            getPurchasers{
              id
              name
              teamPosition
              teamIcon
              color
            }
          }
        `,
        });

        // Stellen Sie sicher, dass die Daten in shoppingSections gespeichert werden
        this.purchasers = data.getPurchasers;

        // Überprüfen, ob shoppingSections vorhanden und nicht leer ist
        if (this.shoppingSections && this.shoppingSections.length > 0) {
          // Speichern aller Farben in einer Variablen
          this.colors = this.purchaser.map(section => section.color);
        } else {

        }
      } catch (error) {
        console.error("Fehler beim Abrufen der ShoppingSections:", error.message);
      }
    },
    async getProjects() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query GetProjectDetails {
              projects {
                projectId
                name
                magazines {
                  magazineId
                  name
                  numberOfPages
                }
              }
            }
          `
        });
        this.projectData = response.data;
        this.magazineData = [];
        if (this.projectId !== 0) {
          this.projectData.projects.forEach((project) => {
            if (project.projectId == this.projectId) {
              this.magazineData.push(project.magazines);
            }
          });
        } else {
          this.projectData.projects.forEach((project) => {
            this.magazineData.push(...project.magazines);
          });
        }

        this.magazineData = this.magazineData.flat();


      } catch (error) {
        console.error("Fehler beim Abrufen der Projektdaten:", error);
      }
    },

    deleteTrue() {
      eventBus.closeModal();
      try {
        if (this.value.onAccept) {

          eventBus.closeModal();
        }
      } catch (e) {
        console.error(e);
      }
    },
    deleteFalse() {
      eventBus.closeModal();
      try {
        if (this.value.onCancel) {
          this.value.onCancel();
        }
      } catch (e) {
        console.error(e);
      }
    }
  },
  watch: {
    projectId: 'getProjects',
    '$route.params': {
      handler: function (params) {
        if (this?.projectId != params?.projectId) {
          this.projectId = params.projectId;
        }
        if (this?.magazineId != params?.magazineId) {
          this.magazineId = params.magazineId;
        }
      },
      deep: true
    }

  }
};
</script>
